import { getAppleMusicTrackInfo } from '@disco/utils/apple-music'
import { getMusicProviderFromUrl } from '@disco/utils/links'
import { getSpotifyTrackId } from '@disco/utils/spotify'
import { getYouTubeVideoId } from '@disco/utils/youtube'

import type { SearchContext } from 'types/search-page'

export const doesContextMatchQuery = (
  context: SearchContext | null | undefined,
  query: string | null | undefined,
): boolean => {
  if (!context?.waveform_url || !query) {
    return false
  }

  const playerType = getMusicProviderFromUrl(query)
  if (!playerType) {
    return false
  }

  try {
    const contextUrl = new URL(context.waveform_url)
    const queryParam = contextUrl.searchParams.get('url')

    if (!queryParam) {
      return false
    }

    let identifier: string | null = null

    switch (playerType) {
      case 'spotify':
        identifier = getSpotifyTrackId(query)
        break
      case 'youtube':
        identifier = getYouTubeVideoId(query)
        break
      case 'applemusic': {
        const trackInfo = getAppleMusicTrackInfo(query)
        identifier = trackInfo?.trackId?.toString() || null
        break
      }
      case 'disco':
        // For disco links, check if the query URL is contained in the waveform URL
        identifier = query
        break
      default:
        return false
    }

    if (!identifier) {
      return false
    }

    return queryParam.includes(identifier)
  } catch {
    return false
  }
}
